import { ReactNode } from 'react'

export const Banner = ({ children }: { children: ReactNode }) => {
  return (
    <div className="left-0 right-0 top-0 z-50 flex h-16 items-center justify-center gap-3 bg-red-500 px-4 md:fixed md:h-10">
      {children}
    </div>
  )
}
